<template>
    <div class="parent" style="height:calc(100vh - 55px);">
        <div>
            <div id="left" class="scroll pageborder" style="height:calc(100vh - 75px); float:left; margin-right:0px; width:48%;">
                <div style="height:50px; padding:0px;">
                    <div class="pageborder" style="float:left; width:150px; height:45px;">
                        <p>WO#: 11-{{woData[0]}}</p>
                    </div>

                    <b-dropdown style="float:left; margin-left:10px; width:150px; height:45px;" v-bind:text="reportFormats[format][2]" :key="updateKey">
            			<b-dropdown-item v-for="(format,i) in reportFormats" v-on:click="setFormat(i)">{{format[2]}}</b-dropdown-item>
            		</b-dropdown>
                </div>

                <div style="width:500px; height:45px; margin-top:10px;">
                    <b style="font-size:24px;">{{reportFormats[format][2]}}</b>
                </div>

                <table class="block" v-if="times.length>0" :key="updatekey">
                    <thead>
                        <tr>
                            <th colspan=5>WORK ORDER INFORMATION</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="woBlock">
                                <p class="woTitle">Vessel</p>
                                <p class="woData">{{woData[1]}}</p>
                            </td>
                            <td class="woBlock" rowspan=2>
                                <p class="woTitle">{{times[1][2]}}</p>
                                <label class="woCheckboxLabel upper" for="checkBoxA">Starboard</label>
                                <input tabindex="2" class="woCheckbox upper" type="checkbox" name="checkBoxA" v-model="sideS" v-on:input="sideChanged('Starboard')"></input>
                                <label class="woCheckboxLabel lower" for="checkBoxB">Port</label>
                                <input tabindex="3" class="woCheckbox lower" type="checkbox" name="checkBoxB" v-model="sideP" v-on:input="sideChanged('Port')"></input>
                            </td>
                            <td class="woBlock">
                                <p class="woTitle">Port</p>
                                <p class="woData">{{woData[2]}}</p>
                            </td>
                            <td class="woBlock">
                                <p class="woTitle">Pier</p>
                                <p class="woData">{{woData[3]}}</p>
                            </td>
                            <td class="woBlock">
                                <p class="woTitle" title="YYYY-MM-DD">Date</p>
                                <input tabindex="6" class="woInput" v-model="woData[4]" title="YYYY-MM-DD"></input>
                            </td>
                        </tr>
                        <tr>
                            <td class="woBlock">
                                <p class="woTitle">{{times[0][2]}}</p>
                                <input tabindex="1" class="woInput" v-model="times[0][5]"></input>
                            </td>
                            <td class="woBlock">
                                <p class="woTitle">{{times[2][2]}}</p>
                                <input tabindex="4" class="woInput" v-model="times[2][5]"></input>
                            </td>
                            <td class="woBlock">
                                <p class="woTitle">{{times[3][2]}}</p>
                                <input tabindex="5" class="woInput" v-model="times[3][5]"></input>
                            </td>
                            <td class="woBlock">
                                <p class="woTitle">Customer</p>
                                <p class="woData">{{woData[7]}}</p>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table class="block" v-if="times.length>0" :key="updatekey">
                    <thead>
                        <tr>
                            <th colspan=10>ADDITIONAL VALUES</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td :key="updatekey" class="meterBox">
                                <p style="width:100%;">{{times[4][2]}}</p>
                                <input tabindex="7" v-model="times[4][5]"></input>
                                <p>{{times[4][6]}}</p>
                            </td>
                            <td :key="updatekey" class="meterBox">
                                <p style="width:100%;">{{times[5][2]}}</p>
                                <input tabindex="8" v-model="times[5][5]"></input>
                                <p>{{times[5][6]}}</p>
                            </td>
                            <td :key="updatekey" class="meterBox">
                                <p style="width:100%;">{{times[6][2]}}</p>
                                <input tabindex="9" v-model="times[6][5]"></input>
                                <p>{{times[6][6]}}</p>
                            </td>
                            <td :key="updatekey" class="meterBox">
                                <p style="width:100%;">{{times[7][2]}}</p>
                                <input tabindex="10" v-model="times[7][5]"></input>
                                <p>{{times[7][6]}}</p>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table class="block">
                    <thead>
                        <tr>
                            <th colspan=3>TIMES</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="j in rows">
                            <td :key="updatekey" class="timeBox" v-for="i in 3" v-if="times.length>getIndex(i,j)">
                                <p>{{times[getIndex(i,j)][2]}}</p>
                                <input tabindex="-1" style="height:20px; top:5px; font-size:10px;" onClick="this.select();" v-model="times[getIndex(i,j)][3]" v-on:input=""></input>
                                <input :tabindex="getIndex(i,j)+2" style="height:30px; bottom:5px;" onClick="this.select();" v-model="times[getIndex(i,j)][4]" v-on:input="timeChanged(getIndex(i,j))"></input>
                            </td>
                            <td v-else class="timeBox">
                                <p>_________</p>
                                <input tabindex="-1" style="height:20px; top:5px; font-size:10px;" onClick="this.select();" v-on:input=""></input>
                                <input :tabindex="getIndex(i,j)+2" style="height:30px; bottom:5px;" onClick="this.select();" v-on:input=""></input>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table class="block">
                    <thead>
                        <tr>
                            <th>COMMENTS/NOTES</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td :key="updatekey"><textarea style="width:100%; height:100px;" v-model="comments" v-on:input=""></textarea></td>
                        </tr>
                    </tbody>
                </table>

                <table class="block">
                    <thead>
                        <tr>
                            <th>REMAINING ITEMS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td :key="updatekey"><textarea style="width:100%; height:100px;" v-model="remainingitems" v-on:input=""></textarea></td>
                        </tr>
                    </tbody>
                </table>

                <table class="block">
                    <thead>
                        <tr>
                            <th colspan=4>MATERIALS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style="width:50px;"></td>
                            <td><b>QTY</b></td>
                            <td><b>Material</b></td>
                            <td><b>Notes</b></td>
                        </tr>
                        <tr v-for="material,id in materials" :key="updatekey">
                            <td style="width:50px;">
                                <button v-on:click="clearMaterial(id)">X</button>
                            </td>
                            <td style="width:10%;">
                                <input v-model=material[2] style="width:100%;"></input>
                            </td>
                            <td style="width:30%;">
                                <autocomplete
    							id="'material'+id"
    							v-model="material[1]"
    							:type="50"
                                :index="id"
    							v-on:finish="setMaterialData"
    							style="width:100%;"
    							></autocomplete>
                            </td>
                            <td style="width:60%;">
                                <input v-model="material[3]" style="width:100%;"></input>
                            </td>
                        </tr>
                        <tr>
                            <td colspan=4><button style="width:100px;" v-on:click="addMaterial()">Add</button></td>
                        </tr>
                    </tbody>
                </table>

                <table class="block">
                    <thead>
                        <tr>
                            <th colspan=4>WORK TIMES</th>
                        </tr>
                    </thead>
                    <tbody key="updatekey">
                        <tr>
                            <td></td>
                            <td><b>From</b></td>
                            <td><b>To</b></td>
                            <td><b>Workers</b></td>
                        </tr>
                        <tr class="workTimesBox" v-for="reportTime, id in reportTimes">
                            <td style="width:50px;">
                                <button v-on:click="clearReportTime(id)">X</button>
                            </td>
                            <td style="width:40%;">
                                <input style="height:20px; top:5px; font-size:10px;" tabindex="-1" onClick="this.select();" v-model="reportTime[1]" v-on:input=""></input>
                                <input style="height:30px; bottom:5px;" v-model="reportTime[2]" onClick="this.select();" v-on:input="reportTimeChanged(id, 2)"></input>
                            </td>
                            <td style="width:40%;">
                                <input style="height:20px; top:5px; font-size:10px;" tabindex="-1" onClick="this.select();" v-model="reportTime[3]" v-on:input=""></input>
                                <input style="height:30px; bottom:5px;" v-model="reportTime[4]" onClick="this.select();" v-on:input="reportTimeChanged(id, 4)"></input>
                            </td>
                            <td style="width:20%;"><input style="height:30px; bottom:5px;" v-model="reportTime[5]" v-on:input=""></input></td>
                        </tr>
                        <tr>
                            <td colspan=4><button style="width:100px;" v-on:click="addReportTime()">Add</button></td>
                        </tr>
                    </tbody>
                </table>

                <table class="block" v-if="times.length>0" :key="updatekey">
                    <thead>
                        <tr>
                            <th colspan=1>STATUS</th>
                        </tr>
                    </thead>
                    <tbody v-if="times[8][2]!=''">
                        <tr>
                            <td class="woBlock" style="height:80px;">
                                <p class="woTitle">{{times[8][2]}}</p>
                                <label class="woCheckboxLabel upper" for="checkBoxA">Yes</label>
                                <input :tabindex="rows*3+11" class="woCheckbox upper" type="checkbox" name="checkBoxA" v-model="statusY" v-on:input="statusChanged('Yes')"></input>
                                <label class="woCheckboxLabel lower" for="checkBoxB">No</label>
                                <input :tabindex="rows*3+12" class="woCheckbox lower" type="checkbox" name="checkBoxB" v-model="statusN" v-on:input="statusChanged('No')"></input>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table class="block">
                    <thead>
                        <tr>
                            <th colspan=3>EMPLOYEE</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <autocomplete
                                :key="updatekey"
    							id="employeeSearch"
    							v-model="employeeSearch"
    							:type="28"
    							v-on:finish="setData"
    							style="width:100%;"
    							></autocomplete>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <button :tabindex="rows*3+13" :disabled=saveDisable class="saveButton" v-on:click="save()">Save</button>
            </div>
            <div id="resize" draggable v-on:dragend="drag($event)"></div>
            <div id="right" class="scroll pageborder" style="height:calc(100vh - 75px); float:right; margin-left:0px; width:48%;">
                <div style="margin-bottom:0px; margin-top:0px; display:inline-block; width:100%;">
                    <button style="float:left; width:30%; font-weight:bold;" v-on:click="changePage(-1)">Previous</button>
                    <p style="float:left; width:150px; text-align:center; margin-bottom:0px; margin-top:5px; font-weight:bold;">Doc #{{documents[pageNumber]}}</p>
                    <button style="float:left; width:30%; font-weight:bold;" v-on:click="changePage(1)">Next</button>
                </div>
                <div style="height:calc(100vh - 145px); margin-bottom:0px; margin-top:0px;">
                    <document
                        ref="doc"
                        :dir="'doc_'+parseInt(documents[pageNumber])+'.jpg'"
                        :doc_id="documents[pageNumber]">
                    </document>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
            sizeX:0.5,

            updatekey:0,
			pageid1:PAGES.EDIT_SERVICE_REPORT_PAGE,
			pageid2:PAGES.EDIT_SERVICE_REPORT_PAGE_ACTIVITIES,
			pageid3:PAGES.EDIT_SERVICE_REPORT_PAGE_REPORT_TIMES,
			pageid4:PAGES.EDIT_SERVICE_REPORT_PAGE_FORMATS,
			pageid5:PAGES.EDIT_SERVICE_REPORT_PAGE_MATERIALS,
			pageid6:PAGES.EDIT_SERVICE_REPORT_PAGE_DOCUMENTS,
            //wonumber, vessel, port, pier, date, bertho, spo, customer
            woData:[12345,0,0,0,0,0,0,0],
            reportFormats:[],
            format:0,

            sideS:false,
            sideP:false,
            statusY:false,
            statusN:false,
            //activityid, jobactivityid, description, date, time, value, valuedescription, valuedescriptionid
            times:[],
            rows:5,
			employeeSearch:'',

            //reporttimeid,fromdate,time,todate,time,numservicemen,workperformed
            reportTimes:[],
            comments:'',
            remainingitems:'',

            //reportmaterialid, materialid. materialname, quantity, notes
            materials:[],

            saveDisable:false,
            documents:[this.term],
            pageNumber:0,
		}
	},
    created(){
        Promise.all(this.getData()).then((results) => {
            api.setWOColors()
            this.prepareData();
        });
    },
    methods:{
        getData(){
            let promises = []
            promises.push(api.postData(
                {
                    type:"search",
                    data:{
						pageid:this.pageid4,
						data:[
	                        this.term
	                    ]
					}
                }
            ).then((res) => {
				if(res.data.data!=null && res.data.data.column_names!=null){
					this.reportFormats = res.data.data.column_data;
				}
	        }));

            promises.push(api.postData(
                {
                    type:"search",
                    data:{
						pageid:this.pageid1,
						data:[
	                        this.term
	                    ]
					}
                }
            ).then((res) => {
				if(res.data.data!=null && res.data.data.column_names!=null){
					this.woData = res.data.data.column_data[0];
				}
	        }));

            let formatId = null;
            if(this.reportFormats.length>0) formatId = this.reportFormats[this.format][0]
            promises.push(api.postData(
                {
                    type:"search",
                    data:{
						pageid:this.pageid2,
						data:[
	                        this.term, formatId
	                    ]
					}
                }
            ).then((res) => {
				if(res.data.data!=null && res.data.data.column_names!=null){
					this.times = res.data.data.column_data;
				}
	        }));

            this.reportTimes = []
            promises.push(api.postData(
                {
                    type:"search",
                    data:{
						pageid:this.pageid3,
						data:[
	                        this.term
	                    ]
					}
                }
            ).then((res) => {
				if(res.data.data!=null && res.data.data.column_names!=null && res.data.data.column_data[0].length>0){
					this.reportTimes = res.data.data.column_data;
				}
	        }));

            this.materials = []
            promises.push(api.postData(
                {
                    type:"search",
                    data:{
						pageid:this.pageid5,
						data:[
	                        this.term
	                    ]
					}
                }
            ).then((res) => {
				if(res.data.data!=null && res.data.data.column_names!=null && res.data.data.column_data[0].length>0){
					this.materials = res.data.data.column_data;
				}
	        }));

            this.documents = []
            promises.push(api.postData(
                {
                    type:"search",
                    data:{
                        pageid:this.pageid6,
                        data:[
                            this.term
                        ]
                    }
                }
            ).then((res) => {
                if(res.data.data!=null && res.data.data.column_names!=null && res.data.data.column_data[0].length>0){
                    for(let i = 0;i<res.data.data.column_data.length;i++){
                        this.documents.push(res.data.data.column_data[i][0])
                    }
                }
            }));

            return promises;
        },
        prepareData(){
            for(let i = 1;i<this.times[this.times.length-1][8];i++){
                if(this.times[i-1][8]!=i){
                    this.times.splice(i-1,0,['','','','','','','','',i,''])
                }
            }

            if(this.woData[4]=='9999-00-00' || this.woData[4]=='0000-00-00')this.woData[4] = ''
            let currentDate = this.woData[4]

            this.employeeSearch = this.woData[8]
            for(let i = 0;i<this.times.length;i++){
                if(this.times[i][3] == currentDate || this.times[i][3] == '0000-00-00'){
                    this.times[i][3]=""
                }
                if(this.times[i][4] == '00:00:00'){
                    this.times[i][4]=""
                }

                if(this.employeeSearch=='' && this.times[i][9].includes("•")){
                    this.employeeSearch = this.times[i][9]
                }
            }

            this.comments = ''
            this.remainingitems = ''
            for(let i = 0;i<this.reportTimes.length;i++){
                if(this.reportTimes[i][1] == currentDate || this.reportTimes[i][1] == '0000-00-00'){
                    this.reportTimes[i][1]=""
                }
                if(this.reportTimes[i][3] == currentDate || this.reportTimes[i][3] == '0000-00-00'){
                    this.reportTimes[i][3]=""
                }
                if(this.reportTimes[i][2] == '00:00:00'){
                    this.reportTimes[i][2]=""
                }
                //console.log(this.reportTimes[i][4]+","+'00:00:00')
                if(this.reportTimes[i][4] == '00:00:00'){
                    this.reportTimes[i][4]=""
                }

                if(this.reportTimes[i][6]!=''){
                    this.comments = this.comments+this.reportTimes[i][6]+"\n"
                    this.reportTimes[i][6] = ''
                }

                if(this.reportTimes[i][7]!=''){
                    this.remainingitems = this.remainingitems+this.reportTimes[i][7]+"\n"
                    this.reportTimes[i][7] = ''
                }
            }

            if(this.reportTimes.length==0){
                this.reportTimes = [[0,'','','','','','','']]
            }

            this.rows = 5
            if(this.times.length-9>15){
                this.rows = Math.ceil((this.times.length-9)/3)
            }

            this.sideS = false
            this.sideP = false
            if(this.times[1][5]=="Starboard"){
                this.sideS = true
            }else if(this.times[1][5]=="Port"){
                this.sideP = true
            }

            this.statusY = false
            this.statusN = false
            if(this.times[8][5]=="Yes"){
                this.statusY = true
            }else if(this.times[8][5]=="No"){
                this.statusN = true
            }

            for(var i = 0;i<this.documents.length;i++){
                if(this.documents[i] == this.term){
                    this.pageNumber = i
                    break
                }
            }

            this.updatekey++;
        },
        timeChanged: function(id){
            this.times[id][4] = this.timeCheck(this.times[id][4])
        },
        reportTimeChanged: function(id, num){
            this.reportTimes[id][num] = this.timeCheck(this.reportTimes[id][num])
            console.log(this.reportTimes)
        },
        timeCheck(timeText){
            let retText = ""
            let text = timeText
            if(text.charAt(2)==":"){
                text = text.substr(0,2)+text.substr(3,5)
            }
            let hour = text.substr(0,2).replace(/\D/g,'')
            let minute = text.substr(2,2).replace(/\D/g,'')
            if(minute.length>0){
                retText = hour+":"+minute
            }else{
                retText = hour
            }

            return retText
        },
        sideChanged: function(side){
            if(side=="Starboard"){
                this.sideS=true
                this.sideP=false
            }else{
                this.sideS=false
                this.sideP=true
            }

            this.times[1][5] = side
        },
        statusChanged: function(status){
            if(status=="Yes"){
                this.statusY=true
                this.statusN=false
            }else{
                this.statusY=false
                this.statusN=true
            }

            this.times[8][5] = status
        },
        getIndex: function(i,j){
            return (i - 1) * this.rows + (j - 1) + 9
        },
        save: function(){
            let pattern = /^(?:\d{4})-(?:\d{2})-(?:\d{2})$/
            let date = this.woData[4]
            let message = ''
            if(pattern.test(date)==false){
                message = message + "Invalid Date\n"
            }
            if(this.employeeSearch==''){
                message = message + "Invalid Employee\n"
            }

            if(message != ''){
                alert(message)
                return;
            }else{
                this.saveDisable = true
                for(let i = 0; i<this.times.length;i++){
                    if(this.times[i][4]!='' && this.times[i][3]==''){
                        this.times[i][3] = this.woData[4]
                    }
                }
                for(let i = 0; i<this.reportTimes.length;i++){
                    if(this.reportTimes[i][2]!='' && this.reportTimes[i][1]==''){
                        this.reportTimes[i][1] = this.woData[4]
                    }
                    if(this.reportTimes[i][4]!='' && this.reportTimes[i][3]==''){
                        this.reportTimes[i][3] = this.woData[4]
                    }
                }

                if(this.reportTimes.length>0){
                    this.reportTimes[0][6] = this.comments;
                    this.reportTimes[0][7] = this.remainingitems;
                }

                let promises = []

                promises.push(api.postData(
    				{
    					type:"insert",
    					data:{
    						pageid:this.pageid1,
    						data:[this.woData[4],this.employeeSearch],
    						term:this.term,
    					}
    				}
    			));

                promises.push(api.postData(
    				{
    					type:"insert",
    					data:{
    						pageid:this.pageid2,
    						data:this.times,
    						term:this.term,
                            employee:this.employeeSearch,
    					}
    				}
    			));

                promises.push(api.postData(
    				{
    					type:"insert",
    					data:{
    						pageid:this.pageid3,
    						data:this.reportTimes,
    						term:this.term,
    					}
    				}
    			));

                promises.push(api.postData(
    				{
    					type:"insert",
    					data:{
    						pageid:this.pageid5,
    						data:this.materials,
    						term:this.term,
    					}
    				}
    			));

                Promise.all(promises).then((results) => {
                    alert("Saved")
                    this.saveDisable = false
                    Promise.all(this.getData()).then((results) => {
                        this.prepareData();
                    });
                });
            }
        },
        drag: function (event) {
            var x = event.screenX / window.innerWidth
            this.sizeX = x
        },
        setFormat: function(index){
            this.format = index;
            Promise.all(this.getData()).then((results) => {
                this.prepareData();
            });
        },
		setData(index, value){
			this.employeeSearch = value;
		},
		setMaterialData(index, value){
			this.materials[index][1] = value;
		},
        addReportTime(){
            this.reportTimes.push([0,'','','','','',''])
            this.updatekey++
        },
        addMaterial(){
            this.materials.push([0,'',0,''])
            this.updatekey++
        },
        clearReportTime(id){
            let oldId = this.reportTimes[id][0]
            this.reportTimes[id] = [0,'','','','','','']
            this.reportTimes[id][0] = oldId
            this.updatekey++
        },
        clearMaterial(id){
            let oldId = this.materials[id][0]
            this.materials[id] = [0,'',0,'']
            this.materials[id][0] = oldId
            this.updatekey++
        },
        changePage: function(amt){
            var len = this.documents.length;
            this.pageNumber += amt
            if(this.pageNumber<0) this.pageNumber = 0
            if(this.pageNumber>=len) this.pageNumber = len-1
        },
    },
	watch:{
		sizeX(){
            document.getElementById("resize").style.left = (this.sizeX*100)+"%"
            document.getElementById("left").style.width = (this.sizeX*100-2)+"%"
            document.getElementById("right").style.width = (100-this.sizeX*100-2)+"%"
		},
	},
    mounted(){
        let stateCheck = setInterval(() => {
			if (this.reportFormats.length>0) {
				clearInterval(stateCheck);
                document.getElementById("resize").style.left = (this.sizeX*100)+"%"
                document.getElementById("left").style.width = (this.sizeX*100-2)+"%"
                document.getElementById("right").style.width = (100-this.sizeX*100-2)+"%"
			}
		}, 100);
    }
}
</script>

<style scoped>
#resize {
  position: absolute;
  z-index: 9;
  cursor: col-resize;
  background-color: #35495E;
  border: 2px solid #d3d3d3;
  height:calc(100vh - 75px);
  width:8px;
  top:10px;
  left:50%;
  margin-left:4px;
  margin-right:4px;
}

thead{
	background: #d0d0d0;
    position:relative;
	top:0px;
	z-index:1;
}

.pageborder{
    border: 3px solid #35495E;
    padding:10px;
}

.block{
    margin-top:5px;
    margin-bottom:5px;
    border: 3px solid #35495E;
    padding:10px;
}

.blockparent{
    display:inline-block;
    width:100%;
}

.woBlock{
    position: relative;
    width:300px;
}

.woTitle{
    position: absolute;
    font-weight:bold;
    line-height:20px;
    width:100%;
    top:10px;
    left:10px;
}

.woData{
    position: absolute;
    width:200px;
    top:10px;
    right:10px;
    text-align: right;
}

.woInput{
    position: absolute;
    width:60%;
    top:5px;
    right:5px;
    text-align: right;
}

.woCheckbox{
    position: absolute;
    width:15px;
    height:15px;
    left:10px;
}

.woCheckboxLabel{
    position: absolute;
    width:100px;
    height:15px;
    left:35px;
}

.upper{
    top:35px;
}

.lower{
    top:55px;
}

.lowest{
    top:75px;
}

.timeBox {
    position:relative;
    height:60px;

}

.timeBox p{
    position:absolute;
    top:5px;
    left:5px;
    width:60%;
    line-height: 18px;
}

.timeBox input{
    position:absolute;
    right:5px;
    width:30%;
}

.meterBox {

}

.meterBox p {
    float:left;
    margin:5px;
}

.meterBox input{
    float:left;
    width:60%;
}

.workTimesBox{
    height:60px;
}

.workTimesBox td{
    position:relative;
    width:100px;
}

.workTimesBox td input{
    position:absolute;
    width:calc(100% - 10px);
    left:5px;
}

.saveButton{
    height:60px;
    margin-left:40%;
    margin-right:40%;
    width:20%;
    font-size:24px;
    font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/components/edit/Edit_Service_Reports.vue